// import USERS from '../../react/fixtures/users';
import { API_URL } from '../../../app-config/constants';
import type MediumUser from '../../../types/MediumUser';
import type { InviteUserDto } from '../../react/features/AddUsers/types';
import { get, post } from '../request';

const RESOURCE = `${API_URL}/users/medium`;

getAll.operation = 'READ';
export function getAll(params?: Partial<{ showLocked: boolean; includeGuests: boolean }>) {
    return get<MediumUser[]>(RESOURCE, { getData: params });
}

getByIds.operation = 'READ';
getByIds.byIds = true;
export function getByIds(ids: string[]) {
    const url = `${RESOURCE}/by-ids`;
    return get<MediumUser[]>(url, { getData: { ids: ids.join(',') } });
    // return Promise.resolve(ids.map(id => USERS.find(u => u.id === id)));
}

getById.operation = 'READ';
getById.byId = true;
export function getById(id: string) {
    const url = `${RESOURCE}/by-id`;
    return get<MediumUser>(url, { getData: { id } });
}

getByLoginname.operation = 'READ';
export function getByLoginname(loginname: string) {
    const url = `${RESOURCE}/by-login`;
    return get<MediumUser>(url, { getData: { loginname } });
}

getByLoginnames.operation = 'READ';
export function getByLoginnames(loginnames: string) {
    const url = `${RESOURCE}/by-logins`;
    return post<MediumUser>(url, { postData: loginnames });
}

getByExternalSystemId.operation = 'READ';
export function getByExternalSystemId(externalSystemId: string) {
    return get<MediumUser>(`${RESOURCE}/by-external-system-id/${externalSystemId}`);
}

getAllSuperUsers.operation = 'READ';
export function getAllSuperUsers() {
    const url = `${RESOURCE}/super-users`;
    return get<MediumUser[]>(url);
}

getAllSuperUsersForCompany.operation = 'READ';
export function getAllSuperUsersForCompany(companyId: string) {
    const url = `${API_URL}/users-for-company/${companyId}/medium/super-users`;
    return get<MediumUser[]>(url);
}

getAllForCompany.operation = 'READ';
export function getAllForCompany(companyId: string, params?: Partial<{ showLocked: boolean; includeGuests: boolean }>) {
    return get<MediumUser[]>(`${API_URL}/users-for-company/${companyId}/medium`, { getData: params });
}

// TODO: enable when Ladda supports array-creates
// invite.operation = 'CREATE';
invite.invalidates = ['getAll'];
export function invite(userInvites: InviteUserDto[]) {
    return post<MediumUser[]>(RESOURCE + '/invite', { postData: userInvites });
}

invalidate.operation = 'NO_OPERATION';
invalidate.invalidates = ['getAll'];
export function invalidate() {
    return Promise.resolve();
}
